import styled from 'styled-components';
import { StyledImageProps } from './Image.types';
import Imgix from 'react-imgix';
const getImageStyle = ({ customStyle }: StyledImageProps) => `
  ${customStyle}
`;

export const StyledImage = styled.div<StyledImageProps>`
  ${(props) => getImageStyle({ ...props })}
`;

export const StyledImageImgix = styled(Imgix)<StyledImageProps>`
  ${(props) => getImageStyle({ ...props })}
`;
